<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="center1 f20">C<span class="small">ONTENTS</span></p>
<p class="noindent_j0" style="margin-top:1.0em;"><a href="#/Text/foreword">Foreword</a></p>
<p class="noindent_j0"><a href="#/Text/ack">Acknowledgments</a></p>
<p class="noindent_j0"><span href="#/Text/intro" title="Link target outside of Sample">Introduction</span></p>
<p class="toc"><span href="#/Text/ch001" title="Link target outside of Sample">1. In the Beginning</span></p>
<p class="toc"><span href="#/Text/ch002" title="Link target outside of Sample">2. Blues Finds a Home</span></p>
<p class="toc"><span href="#/Text/ch003" title="Link target outside of Sample">3. Keeping the Blues Alive</span></p>
<p class="toc"><span href="#/Text/ch004" title="Link target outside of Sample">4. Getting Back to Business</span></p>
<p class="toc"><span href="#/Text/ch005" title="Link target outside of Sample">5. Blues Today</span></p>
<p class="noindent_j0"><span href="#/Text/last" title="Link target outside of Sample">Suggested Reading</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?716291a2